/* eslint-disable react-hooks/exhaustive-deps */
import { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import routes from "./routesData";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import NotFoundPage from "../pages/notFound";
import { useSelector } from "react-redux";
import BackdropLoader from "../components/loader/BackdropLoader";
import NavBar from "../components/navBar";

const AppRoutes = () => {
  return (
    <Routes>
      {routes.map(({ component: Component, ...i }, index) => {
        return (
          <Route
            key={index}
            {...i}
            element={
              <Suspense fallback={<BackdropLoader loading={true} />}>
                {i.isPublic ? (
                  <PublicRoute roles={i.roles} depts={i.depts}>
                    <Component />
                  </PublicRoute>
                ) : (
                  <ProtectedRoute roles={i.roles} depts={i.depts}>
                    <NavBar>
                      <Component />
                    </NavBar>
                  </ProtectedRoute>
                )}
              </Suspense>
            }
          />
        );
      })}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
export default AppRoutes;
